import * as React from "react";
type Props = {
  className?: string,
};
function SvgSnacks2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-snacks2"
      className={className}
    >
      <path
        d="M37.2099 15.3C35.6999 14.94 34.4099 15.63 33.6999 16.09C33.4699 16.17 33.2799 16.26 33.1399 16.36C30.1699 18.34 31.3999 21.14 28.6699 24.73C28.2099 25.3 27.6399 25.92 26.9399 26.58C26.1899 27.26 25.2799 27.96 24.1499 28.68C22.9799 29.43 21.6799 29.69 20.3199 30.81C19.4499 31.53 18.9499 32.45 19.0699 33.35C18.9799 34.78 19.6699 36.43 21.0399 37.42C23.3899 39.12 30.5799 34.88 33.3599 32.29C39.5699 26.48 40.9199 16.2 37.2099 15.3Z"
        fill="#C2DA96"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M10.2698 25.2701C14.0498 25.6701 14.1198 17.1901 12.3498 16.8501C10.2198 16.4501 4.76976 24.9701 10.2698 25.2701Z"
        fill="#794039"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M10.0698 25.2598C10.4698 24.8998 10.7098 24.6198 10.9298 24.0998C12.0698 21.4098 12.3598 18.9298 12.1798 16.8198"
        fill="#794039"
      />
      <path
        d="M10.0698 25.2598C10.4698 24.8998 10.7098 24.6198 10.9298 24.0998C12.0698 21.4098 12.3598 18.9298 12.1798 16.8198"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M9.93016 25.2501C9.82016 25.0201 9.69016 24.4501 9.67016 23.9301C9.67016 23.9301 9.65016 23.2001 9.82016 22.3201C10.0302 21.2401 10.5902 19.1801 12.2302 16.8301"
        fill="#794039"
      />
      <path
        d="M9.93016 25.2501C9.82016 25.0201 9.69016 24.4501 9.67016 23.9301C9.67016 23.9301 9.65016 23.2001 9.82016 22.3201C10.0302 21.2401 10.5902 19.1801 12.2302 16.8301"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M2.4902 16.6699C4.7002 19.3999 10.2902 13.8999 9.3502 12.5299C8.2202 10.8799 -0.909802 12.8899 2.4902 16.6699Z"
        fill="#794039"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M2.37012 16.5301C2.87012 16.5601 3.21012 16.5301 3.69012 16.3301C6.19012 15.3201 8.01012 13.8901 9.26012 12.3901"
        fill="#794039"
      />
      <path
        d="M2.37012 16.5301C2.87012 16.5601 3.21012 16.5301 3.69012 16.3301C6.19012 15.3201 8.01012 13.8901 9.26012 12.3901"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M2.29004 16.4399C2.37004 16.2199 2.65004 15.7599 2.98004 15.4099C2.98004 15.4099 3.44004 14.9199 4.13004 14.4499C4.97004 13.8799 6.69004 12.8999 9.30004 12.4399"
        fill="#794039"
      />
      <path
        d="M2.29004 16.4399C2.37004 16.2199 2.65004 15.7599 2.98004 15.4099C2.98004 15.4099 3.44004 14.9199 4.13004 14.4499C4.97004 13.8799 6.69004 12.8999 9.30004 12.4399"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.17002 27.2301C6.94002 27.2501 7.22002 28.7101 8.14002 29.8301C9.33002 31.2801 10.66 29.9201 12.13 30.2901C15.09 31.0501 13.69 36.3601 10.6 35.9301C9.01002 35.7101 9.06002 33.6401 7.51002 33.2701C5.76002 32.8501 4.67002 34.9501 2.77002 33.8301C0.0100191 32.2101 2.36002 27.2001 5.17002 27.2301Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M16.9901 8.11983C16.9901 8.11983 18.7501 11.9498 15.9801 11.9298C13.2101 11.9098 13.8301 9.14983 13.8301 9.14983C13.8301 9.14983 9.56015 10.3498 9.70015 6.45983C9.84015 2.56983 13.9201 4.91983 13.9201 4.91983L17.0001 8.12983L16.9901 8.11983Z"
        fill="#F9EED8"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M14.3398 6.37998C13.9698 5.66998 13.8698 4.81998 14.1298 3.98998C14.6498 2.33998 16.4098 1.42998 18.0598 1.94998C19.7098 2.46998 20.6198 4.22998 20.0998 5.87998C19.5798 7.52998 17.8198 8.43998 16.1698 7.91998"
        fill="#F9EED8"
      />
      <path
        d="M14.3398 6.37998C13.9698 5.66998 13.8698 4.81998 14.1298 3.98998C14.6498 2.33998 16.4098 1.42998 18.0598 1.94998C19.7098 2.46998 20.6198 4.22998 20.0998 5.87998C19.5798 7.52998 17.8198 8.43998 16.1698 7.91998"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M28.5601 7.50012C28.5601 7.50012 28.3801 3.66012 30.4401 4.04012C32.5001 4.42012 31.2101 6.93012 31.2101 6.93012C31.2101 6.93012 34.7301 6.34012 33.4901 10.0001C32.2401 13.6601 29.9001 10.9201 29.9001 10.9201L28.5601 7.50012Z"
        fill="#F9EED8"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M28.9098 6.77994C29.0498 6.83994 29.1898 6.90994 29.3198 6.99994C29.6598 7.21994 29.9498 7.49994 30.1798 7.82994C30.3498 8.07994 30.4898 8.34994 30.5798 8.63994C30.7898 9.24994 30.8198 9.93994 30.6598 10.6199C30.6098 10.8199 30.5398 11.0299 30.4598 11.2299C29.6998 12.9899 27.7798 13.8599 26.1798 13.1699C25.3798 12.8199 24.7998 12.1499 24.5198 11.3499C24.2398 10.5499 24.2598 9.60993 24.6298 8.72993C25.3898 6.96993 27.3098 6.09994 28.9098 6.78994V6.77994Z"
        fill="#F9EED8"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M33.1402 16.3602C29.1502 19.0202 32.7402 23.1502 24.1602 28.6902C22.9902 29.4402 21.6902 29.7002 20.3302 30.8202C18.8302 32.0702 18.4202 33.8802 20.3802 35.2002C22.5102 36.6402 29.1602 32.8502 31.7502 30.5502C37.5302 25.4102 39.1102 17.0802 35.8402 16.0102C34.8202 15.6802 33.6602 16.0102 33.1502 16.3602H33.1402Z"
        fill="#EDF4E0"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M21.5102 18.04C21.5102 18.04 23.7302 18.91 26.0802 18.22C28.4302 17.53 27.9202 21.57 24.4502 20.92C24.4502 20.92 25.8602 23.28 23.9102 24.16C21.9602 25.04 21.7202 23.09 21.7202 23.09C21.7202 23.09 21.8802 26.37 19.6902 25.66C17.5002 24.95 21.2202 22.62 19.4502 20.47L21.5002 18.04H21.5102Z"
        fill="#F9EED8"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M22.2102 21.3898C21.5302 21.8098 20.6802 21.9698 19.8402 21.7698C18.1602 21.3698 17.1202 19.6798 17.5202 17.9998C17.9202 16.3198 19.6102 15.2798 21.2902 15.6798C22.9702 16.0798 24.0102 17.7699 23.6102 19.4499"
        fill="#F9EED8"
      />
      <path
        d="M22.2102 21.3898C21.5302 21.8098 20.6802 21.9698 19.8402 21.7698C18.1602 21.3698 17.1202 19.6798 17.5202 17.9998C17.9202 16.3198 19.6102 15.2798 21.2902 15.6798C22.9702 16.0798 24.0102 17.7699 23.6102 19.4499"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M31.75 23.95C31.23 23.79 30.52 24.03 30.12 24.38C29.72 24.73 29.6 25.44 30.24 25.6C30.95 25.78 32.82 24.29 31.75 23.95Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M31.1599 27.21C30.7699 27.52 30.3299 28.06 30.5899 28.58C30.7399 28.87 31.1799 29.28 31.5299 29.14C32.2499 28.86 32.0499 26.66 31.1599 27.21Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M32.7402 22.0599C32.2902 21.1799 33.9902 19.5899 34.4102 20.5399C34.6002 20.9699 34.4102 21.6699 34.1502 22.0399C33.8402 22.4899 33.0302 22.6399 32.7402 22.0699V22.0599Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M28.1302 31.6498C27.9502 31.9298 27.4002 32.2198 27.0702 32.0798C26.6602 31.9098 26.8302 31.2698 26.9202 30.9498C27.0402 30.5198 27.3002 30.0898 27.8002 30.3798C28.2102 30.6198 28.3902 31.2398 28.1302 31.6498Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M27.33 27.9899C27.64 27.6799 28.15 27.3799 28.56 27.2299C29.07 27.0299 29.95 27.3899 29.43 27.9799C29.09 28.3699 28.52 28.5899 28.02 28.6799C27.8 28.7199 27.52 28.7599 27.33 28.5999C27.14 28.4399 27.14 28.1599 27.33 27.9899Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M33.5001 23.8899C32.9501 24.0499 32.9701 24.8199 33.2001 25.2199C33.3501 25.4799 33.7601 25.9699 34.1101 25.8499C34.7001 25.6399 34.4201 24.8699 34.2601 24.4799C34.1201 24.1499 33.9401 23.7599 33.5001 23.8899Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M24.62 29.6201C24.97 29.4701 25.72 29.6901 25.81 30.0901C25.92 30.5401 25.43 30.9301 25.06 31.0501C24.69 31.1701 23.99 31.2001 23.94 30.6801C23.91 30.3601 24.32 29.7501 24.62 29.6201Z"
        fill="#FDF6EF"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgSnacks2;
